/** Pick a day in a small sheet: the one day picker the Season screens share, drawn with the app's own month, never a bare date field. */
import { MonthPicker } from "../board/LiveWhen";
import { Sheet } from "./ui/Sheet";

export function DaySheet({ value, min, onPick, onClose }: { value: string; min: string; onPick: (date: string) => void; onClose: () => void }) {
  return (
    <Sheet open onClose={onClose} title="Day">
      <div className="sheet-b dsheet">
        <MonthPicker
          value={value}
          today={min}
          onPick={(date) => {
            onPick(date);
            onClose();
          }}
          onClose={onClose}
        />
      </div>
    </Sheet>
  );
}
